import Axios from "axios";
import React from 'react';

import {useEffect,useState,useRef}from "react";

// FIREBASE
// import { db, storage } from "../../../firebase";
import { db } from "../../../firebase";

import {
  collection,
  getDocs,
  query,
  where,
  addDoc,
  updateDoc,
  doc
} from "firebase/firestore";

// import {
//   ref,
//   uploadBytes,
//   getDownloadURL
// } from "firebase/storage";

import { useLocation } from 'react-router-dom';

import Notification from "../../Notification";

import { useNavigate } from 'react-router-dom';

export default function IssueCommunication() {

  // const [UploadScreenShot, setUploadScreenShot] = useState();

  const [SolutionData, setSolutionData] = useState('');
  const replyBoxRef = useRef(null);


  const [editingReplyId, setEditingReplyId] = useState(null);

  const [ShowReplyHistory, SetShowReplyHistory] = useState([]);

  const [notify, setNotify] = useState({
    isOpen: false,
    messsage: '',
    type: ''
  });

  const navigate = useNavigate();

  const { state } = useLocation();

  const {
    busineName,
    problemTitle,
    problemDescription,
    issueID,
    businessId,
    currentTicketStatus
  } = state;

  let status = currentTicketStatus;
  const [ticketStatus,setTicketStatus] = useState(currentTicketStatus);



useEffect(() => {

showReplyHistory();

}, [issueID]);




  // // FILE UPLOAD
  // const handleFile = (event) => {

  //   const file = event.target.files[0];

  //   if (!file) return;

  //   const ext = file.name
  //     .split(".")[1]
  //     .toLowerCase();

  //   if (
  //     ext !== "jpg" &&
  //     ext !== "jpeg" &&
  //     ext !== "png"
  //   ) {

  //     alert("Please upload JPG JPEG PNG");

  //     return;
  //   }

  //   setUploadScreenShot(file);

  // };




 const handleSubmit = async () => {

try {

if (!SolutionData.trim()) {

setNotify({
isOpen:true,
messsage:"Please write something",
type:"warning"
});

return;

}

/* EDIT MODE */

if(editingReplyId){

const response =
await Axios.post(

`${process.env.REACT_APP_API_URL}api/issues/edit-reply`,

{

reply_id:
editingReplyId,

admin_message:
SolutionData

}

);

console.log(
"EDIT RESPONSE =>",
response.data
);

if(

response.data.status

||

response.status === 200

){

setEditingReplyId(
null
);

setSolutionData("");

SetShowReplyHistory([]);

await showReplyHistory();

setNotify({

isOpen:true,

messsage:
"Reply Updated Successfully",

type:"success"

});

}

}/* NEW REPLY */

/* NEW REPLY */

else{

const payload = {

support_ticket_id:
issueID,

business_id:
businessId,

business_name:
busineName,

admin_message:
SolutionData,

partner_responce:"",

status:
ticketStatus,

problem_title:
problemTitle,

problem_desc:
problemDescription

};

const response =
await Axios.post(

`${process.env.REACT_APP_API_URL}api/issues/reply`,

payload

);

if(
response.data.code
===
"success"
){

setSolutionData("");

await showReplyHistory();

}

setNotify({

isOpen:true,

messsage:
"Reply Sent Successfully",

type:"success"

});

}
setSolutionData("");

SetShowReplyHistory([]);

await showReplyHistory();

}

catch(error){

console.log(
error
);

setNotify({

isOpen:true,

messsage:
"Something went wrong",

type:"error"

});

}

};




      // FIRESTORE SAVE
//       await addDoc(
//         collection(
//           db,
//           "VedMG_partners_issues_admin_response"
//         ),
//         {

//           admin_message: SolutionData,

//           business_id: businessId,

//           business_name: busineName,

//           partner_responce: "",

//           reply_id: Date.now().toString(),

//           screenshot_path: imageUrl,

//           status: currentTicketStatus,

//           support_ticket_id: issueID,

//           problem_title: problemTitle,

//           problem_desc: problemDescription,

//           added_date: new Date().toLocaleString()
//         }
//       );



//       alert("Reply Added Successfully");

//       setSolutionData("");

// setUploadScreenShot(null);

// document.getElementById("file").value="";

// await showReplyHistory();

//     } catch (error) {

//       console.log(error);

//       alert("Something went wrong");

//     }

//   };
console.log({

support_ticket_id:
issueID,

business_id:
businessId,

business_name:
busineName,

admin_message:
SolutionData

});





  // FETCH REPLY HISTORY
const showReplyHistory = async () => {

try {

console.log(
"ISSUE ID =>",
issueID
);

const response =
await Axios.get(
`${process.env.REACT_APP_API_URL}api/issues/reply-list`,
{
params:{
support_ticket_id:
issueID
}
}
);

console.log(
"API RESPONSE =>",
response.data
);

let arr =
response?.data?.data ||
response?.data?.result ||
[];

console.log(
"FINAL ARRAY =>",
arr
);

SetShowReplyHistory(
[...arr]
);

}

catch(error){

console.log(
"SHOW HISTORY ERROR =>",
error
);

}

};

  // SHOW REPLIES
  // SHOW REPLIES
const showReply = (

<div
style={{

height:"520px",

overflowY:"auto",

padding:"25px",

background:"#eef6f7",

borderRadius:"18px",

display:"flex",

flexDirection:"column",

gap:"18px"

}}
>

{

ShowReplyHistory?.map(
(item,index)=>(

<div

key={
item.reply_id
}

style={{

display:"flex",

justifyContent:

item.reply_by==="ADMIN"

?

"flex-end"

:

"flex-start"

}}

>

<div

style={{

maxWidth:"60%",

background:

item.reply_by==="ADMIN"

?

"#dff4cc"

:

"#ffffff",

padding:"16px",

borderRadius:

item.reply_by==="ADMIN"

?

"18px 18px 4px 18px"

:

"18px 18px 18px 4px",

position:"relative",

boxShadow:

"0 4px 12px rgba(0,0,0,.08)"

}}

>

{

item.reply_by==="ADMIN"

&&

(

<div

style={{

position:"absolute",

top:"10px",

right:"10px",

display:"flex",

gap:"8px"

}}

>

<button

onClick={()=>
handleEdit(item)
}

style={{

border:"none",

background:"transparent",

cursor:"pointer",

fontSize:"18px"

}}

>

✏️

</button>

<button

onClick={()=>
handleDelete(
item.reply_id
)
}

style={{

border:"none",

background:"transparent",

cursor:"pointer",

fontSize:"18px"

}}

>

🗑️

</button>

</div>

)

}

<div
style={{

fontWeight:"700",

marginBottom:"10px"

}}
>

{

item.reply_by==="ADMIN"

?

"Admin"

:

item.business_name

}

</div>

<div
style={{

fontSize:"16px",

lineHeight:"1.6"

}}
>

{

item.admin_message

||

item.partner_responce

}

</div>

<div

style={{

marginTop:"12px",

fontSize:"12px",

opacity:.7,

textAlign:"right"

}}

>

{

new Date(
item.added_date
).toLocaleString()

}

</div>

</div>

</div>

)

)

}

</div>

);
  // CHANGE STATUS
 const changeStatus = async (e) => {

try {

const newStatus =
e.target.value;

setTicketStatus(
newStatus
);

/* UPDATE ISSUE TABLE */

await Axios.post(
`${process.env.REACT_APP_API_URL}api/issues/update-status`,
{

issue_id:
issueID,

action_status:
newStatus

}
);

/* UPDATE CHAT TABLE */

const q =
query(

collection(
db,
"VedMG_partners_issues_admin_response"
),

where(
"support_ticket_id",
"==",
issueID
)

);

const querySnapshot =
await getDocs(q);

for(
const item
of
querySnapshot.docs
){

await updateDoc(

doc(
db,
"VedMG_partners_issues_admin_response",
item.id
),

{

status:
newStatus

}

);

}

setNotify({

isOpen:true,

messsage:
"Status Updated",

type:"success"

});

}
catch(error){

console.log(
error
);

}

};

const handleEdit =
(item)=>{

setEditingReplyId(
item.reply_id
);

setSolutionData(
item.admin_message || ""
);

setTimeout(()=>{

replyBoxRef
.current
?.scrollIntoView({

behavior:
"smooth",

block:
"center"

});

replyBoxRef
.current
?.focus();

},300);

};



const handleDelete =
async(replyId)=>{

try{

const confirmDelete =
window.confirm(
"Are you sure?\n\nThis reply will be deleted permanently."
);

if(
!confirmDelete
){

return;

}

await Axios.post(

`${process.env.REACT_APP_API_URL}api/issues/delete-reply`,

{
reply_id:
replyId
}

);

await showReplyHistory();

setNotify({

isOpen:true,

messsage:
"Reply Deleted Successfully",

type:"success"

});

}
catch(error){

console.log(
error
);

setNotify({

isOpen:true,

messsage:
"Delete failed",

type:"error"

});

}

};


  return (

    <>

      <div
        className="content"
        style={{
          float: 'right',
          marginTop: '100px',
          width: '1000px',
          marginRight: '100px',
          paddingBottom: '3%'
        }}
      >

        <div className="">

          <section
            className="card-box"
            style={{
              backgroundColor: 'rgb(96 213 213 / 15%)',
              padding: "20px",
              borderRadius: "15px"
            }}
          >

            {/* TOP DETAILS */}

           <div
style={{
textAlign:"center",
marginBottom:"30px"
}}
>

<h3
style={{
fontWeight:"700"
}}
>
BUSINESS NAME :- {busineName}
</h3>

<h5
style={{
marginTop:"20px"
}}
>
Problem Title :- {problemTitle}
</h5>

<p
style={{
fontSize:"17px",
marginTop:"15px"
}}
>
Problem Description :- {problemDescription}
</p>

<div
style={{
marginTop:"20px"
}}
>

<span
style={{
fontWeight:"600",
marginRight:"10px"
}}
>
Current Status :-
</span>

<select

value={ticketStatus}

onChange={changeStatus}

style={{

background:
ticketStatus==="Resolved"
? "#28c76f"

:
ticketStatus==="Resolving"
? "#ff9f43"

:
"#00cfe8",

color:"#fff",

padding:"8px 18px",

borderRadius:"20px",

border:"none",

fontWeight:"700",

textTransform:"capitalize",

cursor:"pointer",

outline:"none"

}}

>

<option value="Active">
Active
</option>

<option value="Resolving">
Resolving
</option>

<option value="Resolved">
Resolved
</option>

</select>

</div>

<br/>
</div>


            {/* CHAT SECTION */}

<div>

<div>
{showReply}
</div>

<br />
<br />

{

status !== "resolved" ? (

<div
style={{
marginTop:"30px"
}}
>

<textarea

ref={replyBoxRef}

id="problem_description"

placeholder="Write your reply..."

value={SolutionData}

style={{

width:"100%",

height:"120px",

padding:"15px",

borderRadius:"12px",

border:"1px solid #ccc",

resize:"none"

}}

onChange={(e)=>

setSolutionData(
e.target.value
)

}

/>

<br />
<br />

<button

type="button"

className="btn btn-primary"

onClick={handleSubmit}

style={{
minWidth:"140px"
}}

>

Send Reply

</button>



</div>

) : (

<div
style={{
textAlign:"center",
marginTop:"20px",
fontWeight:"700",
color:"red"
}}
>

This ticket has been closed

</div>

)

}





              {/* NOTIFICATION */}

              {

                notify.isOpen ?

                  <Notification
                    notify={notify}
                    setNotify={setNotify}
                  />

                  :

                  ""

              }

            </div>

          </section>

        </div>

      </div>

    </>

  );

}